import { Button } from 'antd';
import React from 'react';

const SuccessStories = () => {
  return (
    <>
    <div className='flex justify-center items-center text-4xl h-48' style={{ fontFamily: "'Playfair Display', serif"}}>Some of the Success Stories</div>
    <div className="grid grid-cols-1 md:grid-cols-2 p-4 bg-gray-100">
      <div className="md:flex md:justify-center">
        <img
          src="https://demo1.imithemes.com/html/born-to-give/images/causeg3.jpg"
          alt="image"
          className="max-w-full h-auto"
        />
      </div>
      <div className="mt-4 md:mt-16 md:ml-4 md:mr-8">
        <h1 className="text-2xl">Lori now studies with her friends</h1>
        <p className="mt-6 md:mr-20">
          In a small village where educational resources are scarce, Lori faced numerous challenges in her pursuit of learning. Thanks to the generous support of our donors and the implementation of a local education project, she now enjoys a vibrant school environment with her peers. This change not only empowers her academically but also enriches her social interactions and personal growth, laying a foundation for a promising future.
        </p>
        <div className="mt-8">
          <Button className="bg-btn-1 hover:bg-blue-800 text-white my-2 md:my-0">
            View Full Story
          </Button>
        </div>
      </div>
    </div>
    </>
  );
};

export default SuccessStories;
